var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgData02 = function SvgData02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "data-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.418 5.716a.985.985 0 0 1-1.403.89l-1.637 1.762a.986.986 0 1 1-1.812.234l-1.365-.878a.983.983 0 0 1-1.055.142L8.412 9.794a.986.986 0 1 1-.45-.396L9.706 7.46a.986.986 0 1 1 1.842-.485.991.991 0 0 1-.032.242l1.37.88a.979.979 0 0 1 1.052-.136l1.637-1.76a.986.986 0 1 1 1.843-.484Zm-.985.985Zm.7 2.971h-1.116v9.151h1.116V9.672Zm-5.955 1.01h-1.116v8.141h1.116v-8.14Zm-2.977 2.1H7.085v6.041H8.2v-6.042Zm4.838-.738h1.116v6.78H13.04v-6.78Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgData02 as ReactComponent };